// extracted by mini-css-extract-plugin
export default {"SideMenuItem":"SideMenuItem_SideMenuItem__oEzXm"};